import tenantErrorcodes from "@irati/identity/errorCodes/Tenant"
import codes from "../../../errorCodes/Login"

export default function (code: string) {
  switch (code) {
    case tenantErrorcodes.TenantNotActive:
      return "errors.PBIDETenantNotActive"
    case codes.RequestUrlParamMissing:
      return "errors.PBLOGRequestUrlParamMissing"
    case codes.RequestBodyInvalid:
      return "errors.PBLOGRequestBodyInvalid"
    case codes.PreconditionFailedErr:
      return "errors.PBLOGPreconditionFailed"
    case codes.PasswordMissing:
      return "errors.PBLOGPasswordMissing"
    case codes.UserDisabled:
      return "errors.PBLOGUserDisabled"
    case codes.UnexpectedLoginChallenge:
      return "errors.PBLOGUnexpectedLoginChallenge"
    case "PBLOGGlobalTenantNotFound":
      return "errors.PBIDESubdomainNotFound"
    case codes.LoginChallengeNewPasswordRequired:
      return "errors.PBLOGLoginChallengeNewPasswordRequired"
    case codes.InvalidLoginDetails:
      return "errors.PBLOGInvalidLoginDetails"
    case codes.RespondToChallengeUnknown:
      return "errors.PBLOGRespondToChallengeUnknown"
    case codes.RespondToChallengeInvalid:
      return "errors.PBLOGRespondToChallengeInvalid"
    case codes.RespondToChallengeFailed:
      return "errors.PBLOGRespondToChallengeFailed"
    case codes.UserNotFound:
      return "errors.PBLOGUserNotFound"
    case codes.PasswordCriteriaFailed:
      return "errors.PBLOGPasswordCriteriaFailed"
    case codes.UserNotConfirmed:
      return "errors.PBLOGUserNotConfirmed"
    case codes.LimitExceeded:
      return "errors.PBLOGLimitExceeded"
    case codes.InvalidConfirmationCode:
      return "errors.PBLOGInvalidConfirmationCode"
    case codes.ExpiredConfirmationCode:
      return "errors.PBLOGExpiredConfirmationCode"
    case codes.ForgotPasswordSamlUser:
      return "errors.PBLOGForgotPasswordSamlUser"
    case codes.OTACExpired:
      return "errors.PBAUTHOTACExpired"
    case codes.InvalidOTAC:
      return "errors.PBAUTHInvalidOTAC"
    default:
      return ""
  }
}
